import script from "./HR06_002INS.vue?vue&type=script&setup=true&lang=js"
export * from "./HR06_002INS.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__